/**
 * Created by andrey on 22.01.2021.
 */

const Map2dAdvice = function () {
    cleverapps.EventEmitter.call(this);

    this.logics = [];

    Map2d.currentMap.on("changeDragging", this.onChangeDragging.bind(this), this);

    cleverapps.userStatus.on("active", this.stopInactiveHint.bind(this), this);
    cleverapps.userStatus.on("inactive_extra_short", this.startInactiveHint.bind(this, { type: "extra_short" }), this);
    cleverapps.userStatus.on("inactive_long", this.startInactiveHint.bind(this, { type: "long" }), this);
    cleverapps.eventBus.on("openInfoView", this.boo.bind(this), this);
    cleverapps.eventBus.on("closeInfoView", this.showHint.bind(this), this);

    cleverapps.gameManager.on("pause", this.onHide.bind(this), this);
    cleverapps.gameManager.on("resume", this.onShow.bind(this), this);
};

Map2dAdvice.prototype = Object.create(cleverapps.EventEmitter.prototype);
Map2dAdvice.prototype.constructor = Map2dAdvice;

Map2dAdvice.prototype.setLogic = function (type, options) {
    let Logic;
    const logics = [];

    switch (type) {
        case Map2d.MERGE: Logic = Map2dAdviceMergeLogic; break;
        case Map2d.BUY_FREE_UNIT:
        case Map2d.EXCHANGE:
        case Map2d.SPAWN: Logic = Map2dAdviceSpawnLogic; break;
        case Map2d.FACTORY_SPEEDUP:
        case Map2d.REFILL: Logic = Map2dAdviceRefillLogic; break;
        case Map2d.HARVEST: Logic = Map2dAdviceHarvestLogic; break;
        case Map2d.OPENFOG: Logic = Map2dAdviceOpenFogLogic; break;
        case Map2d.START_MINING: Logic = Map2dAdviceMineLogic; break;
        case Map2d.SPEED_UP: Logic = Map2dAdviceSpeedupLogic; break;
        case Map2d.START_BUILDING: Logic = Map2dAdviceBuildLogic; break;
        case Map2d.CLICK_UNIT:
        case Map2d.OPENCHEST:
        case Map2d.MISSION_TREE_CLOSED: Logic = Map2dAdviceClickLogic; break;
        case Map2d.FEED_HERO:
        case Map2d.DRAG: Logic = Map2dAdviceDragLogic; break;
        case Map2d.FIELD_PLANT:
        case Map2d.FIELD_HARVEST: Logic = Map2dAdviceFieldLogic; break;
    }

    if (Logic) {
        logics.push(new Logic(options));
    }

    this.logics = logics;
};

Map2dAdvice.prototype.onChangeDragging = function (unit) {
    if (unit) {
        this.boo();
    }
};

Map2dAdvice.prototype.destructor = function () {
    runCleaners(this);
    this.stopHint();
};

Map2dAdvice.prototype.onHide = function () {
    if (!this.paused) {
        this.paused = true;
        clearTimeout(this.showHintTimeout);
        this.hideHint();
    }
};

Map2dAdvice.prototype.onShow = function () {
    if (this.paused) {
        delete this.paused;
        this.showHint();
    }
};

Map2dAdvice.prototype.boo = function () {
    if (!this.hintActive) {
        return;
    }

    this.hideHint();
    clearTimeout(this.showHintTimeout);
    this.showHintTimeout = setTimeout(this.showHint.bind(this), Map2dAdvice.SCARED_TIMEOUT);
};

Map2dAdvice.prototype.hideHint = function () {
    this.move = undefined;
    this.trigger("hideHint");
};

Map2dAdvice.prototype.showHint = function () {
    if (!this.hintActive) {
        return;
    }

    const move = Map2d.currentMap.dragging ? undefined : this.findMove();
    if (!this.isMoveEqual(this.move, move)) {
        this.move = move;
        if (move) {
            this.trigger("showHint", move, this.hintOptions);
            Map2dLocation.currentLocation.tutorial.onShowHint();
        } else {
            this.hideHint();
        }
    }

    const duration = this.getShowHintTimeout();
    clearTimeout(this.showHintTimeout);
    this.showHintTimeout = setTimeout(this.showHint.bind(this), duration);
};

Map2dAdvice.prototype.isMoveEqual = function (move, newMove) {
    if (Boolean(move) !== Boolean(newMove)) {
        return false;
    }

    const hasChanged = function (a, b) {
        if (typeof a !== "object" || typeof b !== "object") {
            return a !== b;
        }
        if (a instanceof Unit || b instanceof Unit) {
            return a !== b;
        }
        if (a instanceof cc.Sprite || b instanceof cc.Sprite) {
            return a !== b;
        }

        const keys = cleverapps.createSet(Object.keys(a).concat(Object.keys(b)));
        for (const key in keys) {
            if (hasChanged(a[key], b[key])) {
                return true;
            }
        }
        return false;
    };

    return !hasChanged(move, newMove);
};

Map2dAdvice.prototype.getShowHintTimeout = function () {
    const logic = this.logics[0];
    if (logic && logic.getShowHintTimeout) {
        return logic.getShowHintTimeout(this.move);
    }
    return Map2dAdvice.ONE_ITERATION_DURATION;
};

Map2dAdvice.prototype.startHint = function (options) {
    if (this.hintActive) {
        return;
    }
    this.hintActive = true;
    this.hintOptions = options || {};

    const start = function () {
        this.showHint();

        clearTimeout(this.stopHintTimeout);
        if (options.callback) {
            this.stopHintTimeout = setTimeout(options.callback, 2 * this.getShowHintTimeout());
        }
    }.bind(this);

    if (options.delay) {
        clearTimeout(this.stopHintTimeout);
        this.stopHintTimeout = setTimeout(start, options.delay);
    } else {
        start();
    }
};

Map2dAdvice.prototype.startHintOnce = function () {
    this.startHint({
        callback: this.stopHint.bind(this)
    });
};

Map2dAdvice.prototype.stopHint = function () {
    if (this.hintActive) {
        delete this.hintOptions;
        delete this.inactiveHintRunning;
        delete this.hintActive;
        clearTimeout(this.showHintTimeout);
        clearTimeout(this.stopHintTimeout);
        this.hideHint();
    }
};

Map2dAdvice.prototype.findMove = function () {
    for (let i = 0; i < this.logics.length; ++i) {
        const move = this.logics[i].findMove();

        if (move) {
            return move;
        }
    }
};

Map2dAdvice.prototype.hasHints = function () {
    return this.logics.length > 0;
};

Map2dAdvice.prototype.stopInactiveHint = function () {
    if (this.inactiveHintRunning) {
        this.stopHint();
    }
};

Map2dAdvice.prototype.startInactiveHint = function (options) {
    options = options || {};

    if (cleverapps.focusManager.isFocused() || this.hintActive || this.paused
        || Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() || Map2dLocation.currentLocation.counter.isActive()
        || cleverapps.config.demoMode
    ) {
        return;
    }

    if (Map2dScroller.currentScroller.isScrollProcessing()) {
        cleverapps.userStatus.reportUserAction();
        return;
    }

    const level = cleverapps.gameLevel.getLevel();
    if ((options.type === "long" && level <= 5 || options.type === "extra_short" && level > 5 || level > 15) && !options.forceHint) {
        return;
    }

    let move;
    const startHint = function (scrollTo) {
        this.inactiveHintRunning = !options.forceHint;
        this.startHint({
            callback: options.once !== false && function () {
                cleverapps.userStatus.reportUserAction();
            },
            delay: options.delay
        });

        if (scrollTo) {
            Map2d.currentMap.focusOnUnit(scrollTo, {
                skipFocusReport: true,
                duration: 2,
                visibleBox: {
                    left: 0.6,
                    right: 0.6,
                    top: 0.5,
                    bottom: 0.6
                }
            });
        }
    }.bind(this);

    if (options.logic) {
        this.setLogic(options.logic);
        startHint();
        return;
    }

    const readyFog = Map2d.currentMap.fogs.findFogReadyToOpen();
    if (readyFog) {
        this.setLogic(Map2d.OPENFOG, {
            targets: readyFog.id
        });
        startHint();
        return;
    }

    const fog = Map2d.currentMap.fogs.findBlockWithProgress();
    const wandsValue = Map2d.currentMap.listAvailableUnits({ code: "wands" }).reduce((sum, wand) => sum + wand.getData().value, 0);

    if (fog && Map2dLocation.currentLocation.wands + wandsValue >= fog.getOpenPrice()) {
        this.setLogic(Map2d.HARVEST, {
            targets: Unit.getAllStagesTargets("wands")
        });

        move = this.findMove();
        if (move) {
            startHint(move.cells && move.cells[0]);
            return;
        }
    }

    const pathIndicator = Map2d.currentMap.pathIndicator;
    if (pathIndicator && pathIndicator.currentPath) {
        const endCell = pathIndicator.currentPath[0];
        this.setLogic(Map2d.START_MINING, { cells: [endCell] });
        if (this.findMove()) {
            startHint();
        }
        return;
    }

    if (!Map2d.currentMap.fogs.isOpened("fog3")) {
        this.setLogic(Map2d.START_MINING);

        move = this.findMove();
        if (move) {
            startHint();
            return;
        }
    }

    this.setLogic(Map2d.MERGE);

    move = this.findMove();
    if (!move) {
        this.setLogic(Map2d.START_MINING);

        if (!this.findMove()) {
            this.setLogic(Map2d.SPAWN);
        }
    }
    startHint();
};

Map2dAdvice.prototype.getCurrentMove = function () {
    return this.move;
};

Map2dAdvice.SCARED_TIMEOUT = 1000;
Map2dAdvice.ONE_ITERATION_DURATION = 2000;
